import { useTranslation } from "react-i18next";
import { BucketIcon } from "@/shared/icons";
import Button from "@/shared/ui/button/Button";

type Props = {
  i18FileName: string;
  onPay: () => void;
  isPaying: boolean;
  handleClear: () => void;
};

export default function CartPayButtons({ i18FileName, onPay, isPaying, handleClear }: Props) {
  const { t } = useTranslation(i18FileName);

  return (
    <div className="grid grid-cols-2 gap-2">
      <Button className="h-11 rounded-xl" onClick={onPay} disabled={isPaying} loading={isPaying}>
        <span className="flex items-center gap-2.5 text-12 uppercase leading-none">
          {t(`${i18FileName}.cart.pay`)}
        </span>
      </Button>
      <Button
        className="group relative ml-0.5 px-6.5 h-11 bg-dark-800 rounded-xl"
        onClick={handleClear}
        variant="soft"
      >
        <span className="absolute size-full top-0 left-0 bg-gradient-accent rounded-xl opacity-0 transition-all ease-in-out duration-300 group-hover:opacity-100" />
        <span className="relative z-1 flex items-center gap-2.5 text-12 uppercase leading-none">
          <BucketIcon className="size-4.5" />
          {t(`${i18FileName}.cart.clearCart`)}
        </span>
      </Button>
    </div>
  );
}
